
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { EmailAuthForm } from "./EmailAuthForm";

interface AuthFormProps {
  onSignUpSuccess: (email: string) => void;
}

export const AuthForm = ({ onSignUpSuccess }: AuthFormProps) => {
  const [isSignUp, setIsSignUp] = useState(false);

  return (
    <Card className="p-6">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold">{isSignUp ? "Create Account" : "Sign In"}</h2>
        <p className="text-sm text-muted-foreground mt-2">
          {isSignUp ? "Sign up with your email to get started" : "Sign in to your account"}
        </p>
      </div>

      <EmailAuthForm isSignUp={isSignUp} onSignUpSuccess={onSignUpSuccess} />

      <div className="mt-4 text-center">
        <button
          type="button"
          onClick={() => setIsSignUp(!isSignUp)}
          className="text-sm text-primary hover:underline"
        >
          {isSignUp ? "Already have an account? Sign In" : "Need an account? Sign Up"}
        </button>
      </div>
    </Card>
  );
};
